export default __webpack_public_path__ + "static/media/change-password.94e3b1b4.svg";